//Get Reducer Call--->
export const getExpensesRequest = (page: number, size: number, search: string, from_date: Date, to_date: Date) => ({
  type: 'GET_EXPENSES_REQUEST',
  payload: { page, size, search, from_date, to_date },
});

export const getExpensesSuccess = (data: any) => ({
  type: 'GET_EXPENSES_SUCCESS',
  payload: { data },
});

export const getExpensesFailure = (data: string) => ({
  type: 'GET_EXPENSES_FAILURE',
  payload: { data },
});

export const resetGetExpenses = () => ({
  type: 'RESET_GET_EXPENSES',
});

//Create Reducer Call--->
export const createExpensesRequest = (data: any) => ({
  type: 'CREATE_EXPENSES_REQUEST',
  payload: data,
});

export const createExpensesSuccess = (data: any) => ({
  type: 'CREATE_EXPENSES_SUCCESS',
  payload: { data },
});

export const createExpensesFailure = (data: string) => ({
  type: 'CREATE_EXPENSES_FAILURE',
  payload: { data },
});

export const resetCreateExpenses = () => ({
  type: 'RESET_CREATE_EXPENSES',
});

//Update Reducer Call--->
export const updateExpensesRequest = ( data: any, id: string) => ({
  type: 'UPDATE_EXPENSES_REQUEST',
  payload: { data, id },
});

export const updateExpensesSuccess = (data: any) => ({
  type: 'UPDATE_EXPENSES_SUCCESS',
  payload: { data },
});

export const updateExpensesFailure = (data: string) => ({
  type: 'UPDATE_EXPENSES_FAILURE',
  payload: { data },
});

export const resetUpdateExpenses = () => ({
  type: 'RESET_UPDATE_EXPENSES',
});
//Delete Reducer Call--->
export const deleteExpensesRequest = ( id: string) => ({
  type: 'DELETE_EXPENSES_REQUEST',
  payload: { id },
});

export const deleteExpensesSuccess = (data: any) => ({
  type: 'DELETE_EXPENSES_SUCCESS',
  payload: { data },
});

export const deleteExpensesFailure = (data: string) => ({
  type: 'DELETE_EXPENSES_FAILURE',
  payload: { data },
});

export const resetDeleteExpenses = () => ({
  type: 'RESET_DELETE_EXPENSES',
});
